import App from "./App.vue";
import Vue from "vue";
import Vuex from "vuex";
import store from "./store";
import router from "./routes";

// Libraries
import VueRouter from "vue-router";
import vClickOutside from "v-click-outside";
import Validations from "./validations";
import { ValidationObserver } from "vee-validate";
import VueResize from "vue-resize";
import heatmapjsVue from "heatmapjs-vue";
import VueGtag from "vue-gtag";
import Hotjar from "vue-hotjar";

Vue.component("ValidationProvider", Validations);
Vue.component("ValidationObserver", ValidationObserver);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(vClickOutside);
Vue.use(VueResize);
Vue.use(heatmapjsVue);

if (process.env.NODE_ENV === "production") {
  Vue.use(
    VueGtag,
    {
      config: {
        id: "UA-129117995-2",
        params: {
          send_page_view: false,
        },
      },
    },
    router
  );

  Vue.use(Hotjar, {
    id: "2418932", // Hotjar Site ID
  });
}

const el = document.getElementById("app");
document.title = process.env.VUE_APP_TITLE;

const app = new Vue({
  data: { loading: false },
  el,
  store,
  router,
  render: (h) => h(App),
});

router.beforeEach((to, from, next) => {
  app.loading = true;
  next();
});

router.afterEach(() => {
  app.loading = false;
});
